
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
const ModalDialog = () => import('@/components/modals/ModalDialog.vue');
const InvitationHeader = () => import('./components/Header.vue');
const InvitationContent = () => import('./components/Content.vue');
const InvitationFooter = () => import('./components/Footer.vue');
const vtitle = () => import('@/routes_new/inner/vacancy/components/vtitle.vue');
const StatusRow = () => import('./components/StatusRow.vue');
const TriggerRow = () => import('./components/TriggerRow.vue');

@Component({
  name: 'prefrences-invitation',

  components: {
    InvitationHeader,
    InvitationContent,
    InvitationFooter,
    vtitle,
    ModalDialog,
    StatusRow,
    TriggerRow
  }
})
export default class PrefrencesInvitation extends Vue {
  @Prop() readonly vacancyId: string;
  @Prop() readonly vacancyName: string;

  private all_change: boolean = false;

  private inviteTemplatesOpened = true;
  private remindTemplateOpened = true;
  private onTop = false;
  private addNewStatus = false;
  private templatesIsClosed = [];
  private isLeave = false;
  private isConfirmationEnabled = false;
  private nextRoute = null;
  private notificationTemplatesLoading = false;

  get vacancy() {
    return this.$store.getters['vacancy/one'];
  }

  get invitation() {
    return this.$store.getters['vacancy/invitation/one'];
  }

  get invitationModel() {
    return {
      active: true,
      title: this.$tr('vacancy.preferences.invitation.personalInvite')
    };
  }

  get registrationModel() {
    return {
      active: true,
      title: this.$tr('vacancy.preferences.invitation.registration')
    };
  }

  get company() {
    return this.$store.getters['company/one'];
  }

  get logo_file() {
    return this.$store.getters['company/logo_file'];
  }

  get modules() {
    return this.$store.getters['vacancy_new/modules/list'];
  }

  get activedModules() {
    return this.modules.filter(item => item.is_active);
  }

  get isDropoutModuleEnabled() {
    if (!this.activedModules || !this.activedModules.length) {
      return false;
    }

    return !!this.activedModules.find(item => item.id === 'test-dropout');
  }
  get isSurveyScreeningModuleEnabled() {
    if (!this.activedModules || !this.activedModules.length) {
      return false;
    }

    return !!this.activedModules.find(item => item.id === 'survey-screening');
  }
  get statuses() {
    return this.$store.getters['dictionary/responseStatuses'];
  }

  get statusesBase() {
    if (!this.statuses) {
      return [];
    }

    return this.statuses.filter(status => status.is_base);
  }

  get statusesOther() {
    if (!this.statuses) {
      return [];
    }

    return this.statuses.filter(status => !status.is_base);
  }

  get templates() {
    return this.$store.getters['vacancy/emailTemplatesAll'];
  }

  get surveyTemplate() {
    if (!this.$store.getters['vacancy/surveyScreeningTemplate']) {
      return null;
    }

    const template = this.$store.getters['vacancy/surveyScreeningTemplate'];
    return Object.assign({}, template, {
      is_standard: true,
      title: this.$tr('vacancy.preferences.application.surveyEmailTemplate')
    });
  }

  get testDropoutTemplate() {
    if (!this.$store.getters['vacancy/testDropoutTemplate']) {
      return null;
    }

    const template = this.$store.getters['vacancy/testDropoutTemplate'];
    return Object.assign({}, template, {
      is_standard: true,
      title: this.$tr('vacancy.modules.test-dropout.email')
    });
  }

  get notificationTemplates() {
    let templates = this.$store.getters['vacancy/notificationTemplate'];
    if (!templates || !templates.length) {
      return [];
    }

    const sortedTemplates = [...templates].sort((a, b) => b.id - a.id);

    return sortedTemplates.map(item => {
      let title = '';
      if (item.type_id === 1) {
        title = this.$tr('vacancy.email.status.notificationAfterThreeDays');
      } else if (item.type_id === 2) {
        title = this.$tr('vacancy.email.status.notification');
      } else if (item.type_id === 3) {
        title = this.$tr('vacancy.email.status.interviewCompleted');
      }
      return Object.assign(item, {
        title,
        is_standard: true,
        active: item.active || false,
        isDeleteDisabled: true,
        editModeUpdated: false
      });
    });
  }

  get templatesDefault() {
    if (!this.templates || !this.templates.length) {
      return [];
    }

    return this.templates.filter(template => template.is_standard);
  }

  get templatesCustom() {
    if (!this.templates || !this.templates.length) {
      return [];
    }

    return this.templates.filter(template => !template.is_standard).filter(template => template.response_status);
  }

  get templatesCustomWithoutStatus() {
    if (!this.templates || !this.templates.length) {
      return [];
    }

    return this.templates.filter(template => !template.is_standard).filter(template => !template.response_status);
  }

  public fetch() {
    this.vacancy.id &&
      this.$store.dispatch('vacancy/invitation/fetch', {
        vacancyId: this.vacancy.id
      });
    this.$store.dispatch('company/fetch');
  }

  @Watch('templates', {
    immediate: true
  })
  templatesChanged(val) {
    this.templatesIsClosed = val.map(template => {
      return {
        id: template.id,
        isClosed: true
      };
    });
  }

  public save(is_continue = 'false') {
    this.reset_change(true);
    this.$store
      .dispatch('vacancy/invitation/save', { vacancyId: this.vacancy.id })
      .then(() => {
        if (this.logo_file) {
          this.$store.dispatch('company/upadte_company_logo', {
            id: this.company.id,
            logoBlob: this.logo_file[0]
          });
        }
      })
      .then(() => {
        this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text')); // уточнить текст для сохранения настроек приглашений
        this.$store.commit('vacancy/invitation/resetChangesTimestamps');
        this.$store.commit('company/set_logo_file', null);
      })
      .catch(() => {
        this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text')); // уточнить текст для ошибки сохранения настроек приглашений
      });
  }
  public reset_change(val) {
    this.all_change = val;
  }

  public fetchStatuses() {
    this.$store.dispatch('dictionary/fetch');
    this.$store.dispatch('vacancy/getEmailTemplatesAll', { id: this.vacancyId });
    this.$store.dispatch('vacancy/getSurveyScreeningTemplate', { id: this.vacancyId });
    this.$store.dispatch('vacancy/getTestDropoutTemplate', { id: this.vacancyId });
    this.$store.dispatch('vacancy/getInterviewNotificationTemplate', { id: this.vacancyId });
  }

  public saveNotificationTemplate(model) {
    this.$store
      .dispatch('vacancy/setInterviewNotificationTemplate', {
        id: this.vacancyId,
        model: Object.assign(model, {
          header: model.template_header,
          text: model.template_text,
          id: model.id
        })
      })
      .then(() => {
        this.notificationTemplatesLoading = true;
        this.$store
          .dispatch('vacancy/getInterviewNotificationTemplate', {
            id: this.vacancyId
          })
          .then(() => {
            this.notificationTemplatesLoading = false;
          });
      });
  }

  public updateNotificationTemplate({ id, model }) {
    this.$store
      .dispatch('vacancy/setInterviewNotificationTemplate', {
        id: this.vacancyId,
        model: Object.assign(model, {
          id: model.id
        })
      })
      .then(() => {
        this.notificationTemplatesLoading = true;
        this.$store
          .dispatch('vacancy/getInterviewNotificationTemplate', {
            id: this.vacancyId
          })
          .then(() => {
            this.notificationTemplatesLoading = false;
          });
      });
  }

  public leavePage(isLeave = false) {
    if (isLeave) {
      this.isLeave = true;
      if (this.nextRoute) {
        this.nextRoute();
      }
    } else {
      this.nextRoute = null;
    }

    this.isConfirmationEnabled = false;
  }

  public templateIsClosed(id) {
    if (!id || !this.templates || !this.templatesIsClosed) {
      return null;
    }

    return this.templatesIsClosed.find(item => item.id === id);
  }

  public addTemplate() {
    const newTemplatesIsClosed = this.templatesIsClosed.map(item => {
      item.isClosed = true;
      return item;
    });
    this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed);

    setTimeout(() => {
      this.addNewStatus = true;
    }, 100);
  }

  public hideAddAndEditMode(id) {
    let newTemplatesIsClosed = this.templatesIsClosed.map(item => {
      item.isClosed = true;
      return item;
    });
    this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed);

    setTimeout(() => {
      if (id) {
        newTemplatesIsClosed = this.templatesIsClosed.map(item => {
          item.isClosed = item.id !== id;
          return item;
        });
        this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed);
      }
    }, 100);

    this.addNewStatus = false;
  }

  public cancelEditMode() {
    const newTemplatesIsClosed = this.templatesIsClosed.map(item => {
      item.isClosed = true;
      return item;
    });
    this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed);

    setTimeout(() => {
      this.addNewStatus = false;
    }, 100);
  }

  created() {
    this.fetch();
    this.fetchStatuses();
  }

  beforeRouteLeave(to, from, next) {
    const isOpened = this.templatesIsClosed ? this.templatesIsClosed.find(item => !item.isClosed) : false;
    if (!this.isLeave && isOpened) {
      this.isConfirmationEnabled = true;
      this.nextRoute = next;
      return;
    }

    return next();
  }
}
